<div class="row" style="padding-bottom: 15px">
  <div class="col-sm-12 right">
    @if (canEdit()) {
      <button mat-raised-button class="pad-btn" [matMenuTriggerFor]="menu">
        <mat-icon>more_vert</mat-icon>
      </button>
    }
    <mat-menu #menu="matMenu">
      <button mat-menu-item (click)="addTaskGroup()" title="Add Task Group">
        <mat-icon aria-hidden="false" aria-label="Add Task Group">add</mat-icon>
        <span>Add Task Group</span>
      </button>
      <button mat-menu-item (click)="deleteTaskGroup()" title="Delete Task Groups">
        <mat-icon aria-hidden="false" aria-label="Delete Task Groups">delete</mat-icon>
        <span>Delete Task Groups</span>
      </button>
    </mat-menu>
  </div>
</div>

<div class="row pc-pt-wrapper">
  <div class="col-12" style="padding: 0;">
    <p-table
      [value]="tableRows"
      dataKey="id"
      [loading]="tableLoading"
      [scrollable]="true"
      scrollHeight="calc(100vh - 320px)"
      [paginator]="tableRows.length > 15"
      [rows]="15"
      [rowsPerPageOptions]="[15, 30, 50]"
      [rowHover]="true"
      sortField="startDateMs"
      [sortOrder]="-1"
      styleClass="p-datatable-sm pc-taskgroup-table"
      currentPageReportTemplate="{first}–{last} of {totalRecords}"
      [showCurrentPageReport]="true">

      <ng-template pTemplate="header">
        <tr>
          <th pSortableColumn="name">Name <p-sortIcon field="name" /></th>
          <th pSortableColumn="startDateMs">Start Date <p-sortIcon field="startDateMs" /></th>
          <th pSortableColumn="endDateMs">End Date <p-sortIcon field="endDateMs" /></th>
          <th pSortableColumn="totalTasks"># of Tasks <p-sortIcon field="totalTasks" /></th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-g>
        <tr class="pc-row" (click)="openTaskGroup(g)">
          <td>
            <span class="pc-name">
              <span class="pc-dot" [style.background]="g.color || '#9aa39d'"></span>
              <span class="pc-name-text">{{ g.name }}</span>
            </span>
          </td>
          <td>{{ formatDate(g.startDate) }}</td>
          <td>{{ formatDate(g.endDate) }}</td>
          <td>{{ g.totalTasks }}</td>
        </tr>
      </ng-template>

      <ng-template pTemplate="footer">
        @if (tableRows.length > 0) {
          <tr class="pc-footer">
            <td colspan="3" class="pc-footer-label">
              {{ tableRows.length }} task group{{ tableRows.length === 1 ? '' : 's' }}
            </td>
            <td class="pc-footer-total">{{ totalTasks | number }}</td>
          </tr>
        }
      </ng-template>

      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="4" class="pc-empty">{{ tableLoading ? 'Loading task groups…' : 'No task groups to show.' }}</td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>

<div class="row" style="padding: 15px 0px">
  <div class="col-sm-12 right">
    <button class="gridbtn" mat-raised-button (click)="exportAsCSV()">Export as CSV</button>
  </div>
</div>
